import script from "./permissions-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./permissions-editor.vue?vue&type=script&setup=true&lang=js"

import "./permissions-editor.vue?vue&type=style&index=0&id=769a080e&lang=scss"

const __exports__ = script;

export default __exports__